import { Enrolment } from "@models/enrolment"
import { MatrixClass } from "@models/matrix-class"
import { Contact } from "@models/contact"

export class EnrolmentsStore {

  constructor(
    public enrolments: Enrolment[] = [],
    public potentialClasses: MatrixClass[] = [],
    public selectedClass: MatrixClass = new MatrixClass(),
    public selectedContact: Contact = new Contact(),
    public editableEnrolment: Enrolment = new Enrolment(),
    public enrolmentsToRollover: Enrolment[] = [],
  ) {}

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/enrolment.ts